import { BRANCH, CURRENT_LANG, DEFAULT_LANGUAGE, ISMAINBRANCH, STAGE } from "../config";

export const LL = (path) => {
    let newPath = path
    newPath = getPathPrefix() + newPath
    return newPath
}

function getPathPrefix() {
    if(!ISMAINBRANCH && STAGE && STAGE !== "dev"){
        if(CURRENT_LANG !== DEFAULT_LANGUAGE){
            return `/branch/${BRANCH}/${CURRENT_LANG}` 
        }
        return `/branch/${BRANCH}`
    }else if(CURRENT_LANG !== DEFAULT_LANGUAGE){
        return `/${CURRENT_LANG}`
    }
    return ""
}

function switchLanguage(targetLang) {
    let newPath = window.location.pathname
    if(targetLang === CURRENT_LANG){
        return newPath
    }
    newPath = removeLanguageFromPath(newPath)
    newPath = addLanguageToPath(newPath, targetLang)
    return newPath
}

function removeLanguageFromPath(path){
    if(CURRENT_LANG === DEFAULT_LANGUAGE){
        return path
    }
    return path.replace(CURRENT_LANG+"/", "")
}

function addLanguageToPath(path, targetLang){
    if(targetLang === DEFAULT_LANGUAGE){
        return path
    }
    let newPath = path
    if(!ISMAINBRANCH){
        const branchPrefix = "/branch/" + BRANCH
        const route = newPath.replace(branchPrefix, "")
        newPath = branchPrefix + "/" + targetLang + route
    }else{
        newPath = "/" + targetLang + path
    }
    
    return newPath
}

export {
    switchLanguage,
    getPathPrefix
}
